import React, { useEffect } from 'react';
import { Typography, Box, Paper } from '@mui/material';
import Title from '../../sharedcomponents/title/title';

const HotelCardSummary = (props) => {
    const [hotelRoomTypeData, setHotelRoomTypeData] = React.useState([
        { id: 1, name: 'Complimentary', used: 0, alloted: 0 },
        { id: 2, name: 'For Purchase', used: 0, alloted: 0 },
        { id: 3, name: 'Waitlist Request', used: 0, alloted: 0 },
    ]);

    const cardColors = {
        complimentary: '#E4EDFF',
        purchase: '#C4D6FA',
        waitlist: '#95B5F3',
    };

    useEffect(() => {
        let compUsedCount = 0;
        let compAllotedCount = 0;
        let purchaseUsedCount = 0;
        let purchaseAllotedCount = 0;
        let waitlistUsedCount = 0;
        let waitlistAllotedCount = 0;
        
        props.filterdata.forEach((item) => {
            item.row.forEach((rowItem) => {
                if (rowItem.hotelSettingRemainingcount) {
                    rowItem.hotelSettingRemainingcount.length > 0 &&
                        rowItem.hotelSettingRemainingcount.forEach(
                            (remaining) => {
                                switch (rowItem.key) {
                                    case 'Complimentary':
                                        compUsedCount += parseInt(
                                            remaining.comp
                                        );
                                        break;
                                    case 'forpurchase':
                                        purchaseUsedCount += parseInt(
                                            remaining.pay
                                        );
                                        break;
                                    default:
                                        break;
                                }
                            }
                        );
                }

                if (rowItem.hotelSettingData) {
                    rowItem.hotelSettingData.length > 0 &&
                        rowItem.hotelSettingData.forEach((setting) => {
                            switch (rowItem.key) {
                                case 'Complimentary':
                                    compAllotedCount += parseInt(setting.comp);
                                    break;
                                case 'forpurchase':
                                    purchaseAllotedCount += parseInt(
                                        setting.pay
                                    );
                                    break;
                                default:
                                    break;
                            }
                        });
                }
            });
        });

        props.data.forEach((item) => {
            if (item.actualData.hotelRoomTaxID == 3) {
                if (item.actualData.requestStatus == 'Approved') {
                    waitlistUsedCount++;
                } else {
                    waitlistAllotedCount++;
                }
            }
        });

        setHotelRoomTypeData([
            {
                id: 1,
                name: 'Complimentary',
                used: compUsedCount,
                alloted: compAllotedCount,
            },
            {
                id: 2,
                name: 'For Purchase',
                used: purchaseUsedCount,
                alloted: purchaseAllotedCount,
            },
            {
                id: 3,
                name: 'Waitlist Request',
                used: waitlistUsedCount,
                alloted: waitlistAllotedCount,
            },
        ]);
    }, [props]);

    const totalUsed = hotelRoomTypeData.reduce(
        (total, type) => total + type.used,
        0
    );
    const totalAlloted = hotelRoomTypeData.reduce(
        (total, type) => total + type.alloted,
        0
    );

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Box sx={{ padding: '0 8px', mx: 1.2, my: 2 }}>
                <Title title={'Hotel Summary Report'}></Title>
            </Box>
            <Box sx={{ display: 'flex', width: '100%', flexWrap: 'wrap' }}>
                {hotelRoomTypeData.map((type) => (
                    <Paper
                        key={type.id}
                        elevation={3}
                        sx={{
                            width: '240px',
                            height: '155px',
                            p: '10px',
                            backgroundColor:
                                type.name === 'For Purchase'
                                    ? cardColors.purchase
                                    : type.name === 'Waitlist Request'
                                    ? cardColors.waitlist
                                    : cardColors.complimentary,
                            ml: '15px',
                            mb: '15px',
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                justifyContent: 'space-between',
                                height: '100%',
                            }}>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    color: '#1D428A',
                                }}>
                                {type.name}
                            </Typography>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                }}>
                                <Typography
                                    sx={{
                                        fontWeight: 'bold',
                                        color: '#000000',
                                    }}>
                                    {type.name == 'Waitlist Request'
                                        ? 'Approved/Alloted :'
                                        : 'Used :'}
                                </Typography>
                                <Typography>{type.used}</Typography>
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                }}>
                                <Typography
                                    sx={{
                                        fontWeight: 'bold',
                                        color: '#000000',
                                    }}>
                                    {type.name == 'Waitlist Request'
                                        ? 'Pending :'
                                        : 'Alloted :'}
                                </Typography>
                                <Typography>{type.alloted}</Typography>
                            </Box>
                        </Box>
                    </Paper>
                ))}
                <Paper
                    elevation={3}
                    sx={{
                        width: '240px',
                        height: '155px',
                        p: '10px',
                        backgroundColor: '#7299e7',
                        ml: '15px',
                        mb: '15px',
                    }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            justifyContent: 'space-between',
                            height: '100%',
                        }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: 'center',
                                color: '#1D428A',
                            }}>
                            Total Count
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                            }}>
                            <Typography
                                sx={{ fontWeight: 'bold', color: '#000000' }}>
                                Total Used:
                            </Typography>
                            <Typography>{totalUsed}</Typography>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                            }}>
                            <Typography
                                sx={{ fontWeight: 'bold', color: '#000000' }}>
                                Total Allotment:
                            </Typography>
                            <Typography>{totalAlloted}</Typography>
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
};

export default HotelCardSummary;
